import { List } from 'antd'
import { InfoCircle } from 'iconsax-react'

import { ProfileList } from '../components'
import { Task } from '../types'
import { TaskMeta } from './TaskMeta'
import { TaskTitle } from './TaskTitle'

export const TaskItem = ({ ...item }: Task) => {
  return (
    <List.Item className="pointer">
      <List.Item.Meta
        avatar={<InfoCircle size="16" />}
        title={<TaskTitle title={item.title} />}
        description={<TaskMeta {...item} />}
      />
      <ProfileList items={item.users} />
    </List.Item>
  )
}
